import { render } from "./MarkdownWYSIWYG.vue?vue&type=template&id=8de8680a&scoped=true"
import script from "./MarkdownWYSIWYG.vue?vue&type=script&lang=ts"
export * from "./MarkdownWYSIWYG.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-8de8680a"

export default script